export default "__VITE_ASSET__zLu2CEoS__"